const LAST_UPDATED = "February 2026";

export default function Privacy() {
  return (
    <div className="min-h-screen bg-zinc-950 text-zinc-100" data-testid="privacy-page">
      <div className="mx-auto max-w-3xl px-6 py-12">
        <p className="mb-1 text-xs uppercase tracking-[0.25em] text-zinc-500">Legal</p>
        <h1 className="text-3xl font-semibold tracking-tight sm:text-4xl">
          TrueBeliever Auto-Clipper — <span className="text-amber-400">Privacy Policy</span>
        </h1>
        <p className="mt-2 text-xs text-zinc-500">Last updated: {LAST_UPDATED}</p>

        <div className="prose mt-10 space-y-6 text-sm leading-relaxed text-zinc-300">
          <section>
            <h2 className="mb-2 text-base font-semibold text-zinc-100">1. Data we collect</h2>
            <ul className="ml-5 list-disc space-y-1">
              <li>
                <strong className="text-zinc-100">OAuth access and refresh tokens</strong> for each
                connected platform (Restream, YouTube, Facebook Page, Instagram Business, TikTok),
                issued to us by you via each platform's standard OAuth consent screen.
              </li>
              <li>
                The <strong className="text-zinc-100">list of clips posted</strong> by the tool —
                clip identifier, target platform, timestamp, and the resulting platform URL on success.
              </li>
              <li>
                Operational <strong className="text-zinc-100">error logs</strong> needed to diagnose
                failures (which API call failed, status code, error message).
              </li>
            </ul>
          </section>

          <section>
            <h2 className="mb-2 text-base font-semibold text-zinc-100">2. How data is stored</h2>
            <p>
              All data is stored in a private MongoDB database. OAuth tokens are
              <strong className="text-zinc-100"> encrypted at rest</strong> using Fernet symmetric
              encryption (256-bit key held only in the backend's environment, never written to the
              database).
            </p>
          </section>

          <section>
            <h2 className="mb-2 text-base font-semibold text-zinc-100">3. How tokens are used</h2>
            <p>
              Your OAuth tokens are used <strong className="text-zinc-100">solely to publish your
              own content to your own connected accounts</strong> on YouTube, Facebook Page, Instagram
              Business, and TikTok. The tool reads source video material only from Restream (your
              own livestream provider).
            </p>
          </section>

          <section>
            <h2 className="mb-2 text-base font-semibold text-zinc-100">4. Sharing</h2>
            <p>
              <strong className="text-zinc-100">No data is shared with third parties.</strong> Your
              OAuth tokens are never transmitted to any party other than the platform that issued
              them, and the AI hashtag/caption generation call sends only the clip's title and
              transcript text (never tokens or account identifiers) to the underlying LLM provider.
            </p>
          </section>

          <section>
            <h2 className="mb-2 text-base font-semibold text-zinc-100">5. Your control</h2>
            <p>
              You can disconnect any platform at any time from the dashboard. Disconnecting
              <strong className="text-zinc-100"> immediately deletes</strong> the stored tokens for
              that platform. To revoke from the platform's side as well, you may also remove the app
              from your platform's connected-apps page (e.g., Meta's Business Integrations, Google
              Account → Security → Third-party access, TikTok → Settings → Manage app permissions).
            </p>
          </section>

          <section>
            <h2 className="mb-2 text-base font-semibold text-zinc-100">6. Retention</h2>
            <p>
              Tokens are retained for as long as the connection is active. Post-history entries are
              retained indefinitely so the scheduler can avoid reposting the same clip. You may
              request full deletion at any time by emailing the contact below.
            </p>
          </section>

          <section>
            <h2 className="mb-2 text-base font-semibold text-zinc-100">7. Contact</h2>
            <p>
              For privacy questions, data-deletion requests, or any other concern, write to{" "}
              <a className="text-amber-300 underline" href="mailto:4thefam@truebelieverfam.com">
                4thefam@truebelieverfam.com
              </a>
              .
            </p>
          </section>
        </div>

        <footer className="mt-12 border-t border-zinc-900 pt-6 text-xs text-zinc-600">
          <a href="/" className="hover:text-zinc-400">← Back to dashboard</a> · <a href="/terms" className="hover:text-zinc-400">Terms of Service</a>
        </footer>
      </div>
    </div>
  );
}
